import { render } from "./Register.vue?vue&type=template&id=8be70c46&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=8be70c46&scoped=true&lang=css"

import exportComponent from "C:\\Users\\noklo\\Documents\\GitHub\\Rayong\\Rayong-query-community\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8be70c46"]])

export default __exports__